export function removeTagAndContents(xmlContent, tagName) {
    if (!xmlContent || !tagName) {
        return xmlContent;
    }

    // Convert to string if it's a Buffer
    if (typeof xmlContent !== 'string') {
        xmlContent = xmlContent.toString();
    }

    const regex = new RegExp(`<${tagName}[^>]*>.*?</${tagName}>`, 'gs');
    return xmlContent.replace(regex, '');
}